import React, { useState,useEffect } from 'react';
import {Box,Typography,Button} from '@mui/material'
import useMediaQuery from '@mui/material/useMediaQuery';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import {IconButton} from "@mui/material"
import {useSelector, useDispatch} from 'react-redux';
import {styled, useTheme} from '@mui/material/styles'
import { useNavigate,Navigate } from 'react-router-dom';
import { add_test } from '../Redux/testSlice';
import { add_tests } from '../Redux/testsSlice';
import get_tests_all from "../Redux/reducers/get_tests_all"
import { Alarm, ArrowCircleRightOutlined, ArrowDropDownOutlined, CalendarTodayOutlined, CopyAllRounded, FileOpenTwoTone, NumbersTwoTone, QuizOutlined, Remove } from '@mui/icons-material';
import { FileOpen, TitleRounded } from '@mui/icons-material';
import { add_assessment } from '../Redux/templatesSlice';
import CardViewDialog from './CardViewDialog';
import { add_candidates } from '../Redux/settingSlice';

const DescriptionText = ({text,limit})=>{
	const displayText = text?.length > limit ? text?.substring(0,limit) + '...' : text;
	return <Typography  style={{fontWeight:500,fontSize:13,color:'white',marginTop:9}}> {displayText} </Typography>
}

const MaxText = ({navigate,dispatch,tst,text,limit,setVisible})=>{
	const displayText = text?.length > limit ? text?.substring(0,limit) + '...' : text;
	return <Button onClick={(e)=>{
	  e?.preventDefault()
	  setVisible(false)
	  dispatch(add_test(tst))
	  if(tst?.isTest){
		navigate("/testInfo")
	  }else{
		dispatch(add_assessment(tst))
		navigate("/assessmentInfo")
	  }
	}}  style={{fontWeight:500,fontSize:11,color:'white',marginTop:9,fontFamily:"dinofans",color:"gold",borderWidth:0}}> {displayText} </Button>
  }

const ContainerBox = styled(Box, {
})(({ theme}) => ({
    transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
}),
overflowY: 'auto',
overflowX: 'hidden',
'&::-webkit-scrollbar': {
    width: 10,
    backgroundColor: '#000000'
},
'&::-webkit-scrollbar-thumb': {
    backgroundColor: '#ffffff',
    borderRadius: 10
},
minHeight:450,
maxHeight:500
})
);

const CandidateDialog = ({visible,setVisible,data})=>{

const theme = useTheme()
const user = useSelector(state => state?.auth.user);
const candidates = useSelector(state => state?.setting.candidates);
const size_sm = useMediaQuery(theme.breakpoints.up('sm'));
const [loading,setLoading] = useState(false)
const dispatch = useDispatch()
const [results, setResults] = useState(data || []);
const [imageData, setImageData] = useState("https://");
const [showModal, setShowModal] = useState(false);
const navigate = useNavigate()

const onOpen = () => {
	setVisible(true);
};
const onClose = () => {
	setVisible(false);
};


return(    
	<Dialog open={visible} onClose={onClose} sx={{borderRadius:10,justifyContent:"center",textAlign:"left"}}>
		<DialogTitle sx={{background:theme.palette.background.default}}> 
			<Box width="90%" display="flex" flexDirection="row" justifyContent="flex-start" alignContent="center">
				<IconButton sx={{marginTop:3}}>
					<FileOpen fontSize='small'/>
				</IconButton>					
				<Typography mr={2} mt={4} style={{fontSize:15,fontWeight:400,fontFamily:"dinofans"}}>
					Selected candidates
				</Typography>		
			</Box>
            <Typography mr={2} mt={1} style={{fontSize:13}}>
                {data?.length ? data?.length : 0} candidate(s)
            </Typography>
		</DialogTitle>
		<DialogContent m={theme.spacing(1)} sx={{minWidth:{xs:300,md:400},justifyContent:"center",textAlign:"center",background:theme.palette.background.default}}>
			<ContainerBox justifyContent="center" alignItems="center" width="100%">
				{
				(data?.length == 0 ) && (
					<Box justifyContent="center" alignItems="center" width="100%" p={1}>
						<Box justifyContent="center" alignItems="center" >
							<img  width={50} height={80} src="https://res.cloudinary.com/irihocloud/image/upload/v1731198104/r14klvgmrdt5syskccyi.gif" alt="keep up" />
						</Box>
						<Typography style={{fontWeight:500,fontSize:11,color:'white',marginTop:5}}>
							Candidates could not be found
						</Typography>   
					</Box>
					)
				} 
				{
				data?.map((item,index)=>{
					return(
					<Box key={index} sx={{padding:1,borderRadius:2,margin:1,width:"95%",justifyContent:"space-between",alignContent:"center",flexDirection:"row",display:"flex",flexWrap:"wrap"}}>
						<Box sx={{display:{xs:"none",md:"flex"}}} flexDirection="row">
                            <Typography sx={{fontWeight:500,fontSize:13,color:'white',marginRight:1,fontFamily:"dinofans"}}>
                                {index+1} #
                            </Typography>
                            <img resizemode="cover" src={require("../assets/avatar.jpg")} width={50} height={50} style={{borderRadius:10}}/>
                        </Box>
                        <Box>
                            <Typography style={{fontWeight:500,fontSize:11,color:'white',marginTop:5,fontFamily:"dinofans"}}>
                                {item?.user?.first_name} {item?.user?.last_name}
                            </Typography> 
                            <Typography style={{fontWeight:500,fontSize:11,color:'gold',marginTop:5}}>
                                {item?.email}
                            </Typography> 
                        </Box>
                        <Button onClick={(e)=>{
                            e?.preventDefault()
                            setImageData(item?.user?.cv)
                            setShowModal(true)
                        }} sx={{background:"#fff",color:"#000",margin:1,height:30,fontFamily:"dinofans",fontSize:12}} variant="outlined">
                            View
                        </Button>
					</Box>
					)
				})
	            }		
			</ContainerBox>
            <CardViewDialog data={imageData} visible={showModal} setVisible={setShowModal}/>
		</DialogContent>
	</Dialog>
	)
}

export default CandidateDialog